<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.beginning_balance_feature.date') }}
          <span class="text-danger">*</span>
        </label>
        <ts-date-picker-input v-model="model.balance_date" />
        <div class="validate" v-if="errors.has('balance_date')">
          {{ errors.first('balance_date') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.beginning_balance_feature.delivered_by') }}
          <span class="text-danger">*</span>
        </label>
        <ts-search-select
          v-model.number="model.delivered_by"
          :options="deliveredByOptions"
        ></ts-search-select>
        <div class="validate" v-if="errors.has('delivered_by')">
          {{ errors.first('delivered_by') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.beginning_balance_feature.currency') }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-group">
          <select
            v-model.number="model.currency_id"
            @change="currencyChange"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('currency_id') }"
          >
            <option value="" disabled selected style="display: none;">
              --{{
                $t('addministration.beginning_balance_feature.select')
              }}--</option
            >
            <option
              v-for="(currency, index) in currencies"
              :key="index"
              :value="currency.currency_id"
            >
              {{ currency.currency_name_en }} |
              {{ currency.currency_code }}
            </option>
          </select>
          <div class="input-group-addon">
            <router-link
              class="text-info"
              :to="{
                name: 'currency'
              }"
              v-tooltip="
                $t('addministration.beginning_balance_feature.add_currency')
              "
            >
              <i class="fas fa-plus"></i>
            </router-link>
          </div>
        </div>
        <div class="validate" v-if="errors.has('currency_id')">
          {{ errors.first('currency_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.beginning_balance_feature.amount') }}
          <span class="text-danger">*</span>
        </label>
        <div class="input-group">
          <div v-if="sign" class="input-group-addon">
            {{ sign }}
          </div>
          <input
            v-model="model.delivered_amount"
            type="text"
            ref="delivered_amount"
            class="form-control kh-font"
            :class="{ 'is-invalid': errors.has('delivered_amount') }"
            :placeholder="
              $t(
                'addministration.beginning_balance_feature.enter_delivered_amount'
              )
            "
          />
        </div>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('delivered_amount') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.beginning_balance_feature.received_by') }}
          <span class="text-danger">*</span>
        </label>
        <ts-search-select
          v-model.number="model.received_by"
          :options="deliveredByOptions"
        ></ts-search-select>
        <div class="validate" v-if="errors.has('received_by')">
          {{ errors.first('received_by') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.beginning_balance_feature.description') }}
        </label>
        <textarea
          v-model="model.description"
          rows="3"
          class="form-control"
          :class="{ 'is-invalid': errors.has('description') }"
          :placeholder="
            $t('addministration.beginning_balance_feature.enter_description')
          "
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('description')">
          {{ errors.first('description') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('addministration.beginning_balance_feature.cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('addministration.beginning_balance_feature.update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('addministration.beginning_balance_feature.save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'beginning-balance-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        balance_date: moment().format('DD-MM-YYYY'),
        delivered_by: '',
        delivered_amount: '',
        currency_id: '',
        description: '',
        received_by: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      sign: ''
    }
  },
  created() {
    this.setEdit()
  },
  computed: {
    ...mapState('beginningBalance', ['currencies']),
    deliveredByOptions() {
      return this.$store.state.beginningBalance.users.map(el => ({
        value: el.user_id,
        text: el.full_name
      }))
    }
  },
  methods: {
    cancel() {
      this.sign = ''
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'beginning-balance' })
    },
    currencyChange() {
      this.sign = this.currencies.filter(
        c => c.currency_id == this.model.currency_id
      )[0].currency_sign
      this.$refs.delivered_amount.focus()
    },
    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'beginningBalance/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.sign = ''
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'beginningBalance/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'beginning-balance' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.sign = ''
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      ;(this.model.delivered_by = ''),
        (this.model.balance_date = moment().format('DD-MM-YYYY')),
        (this.model.delivered_amount = ''),
        (this.model.currency_id = ''),
        (this.model.description = ''),
        (this.model.received_by = '')
    }
  },
  watch: {
    'model.currency_id': function(value) {
      if (value) {
        this.currencyChange()
      }
    },
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
